<app-dialog-header [title]="'MODULE.MANAGE_COMPLETION'" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div class="content p-24 pb-0" fxLayout="column" fxLayoutAlign="start">
    <mat-table class="mat-elevation-z0" #table [dataSource]="dataSource" matSort>
        <!-- Section Column -->
        <ng-container matColumnDef="section">
            <mat-header-cell class="pl-24" *matHeaderCellDef>
                {{ 'PAGE.USER_FORM.TAB.CERTIFICATES.CONTENT_PROGRESS.LABELS.SECTIONS' | translate }}
            </mat-header-cell>
            <mat-cell *matCellDef="let userSection">
                <div fxLayout="row" fxLayoutAlign="space-between center">
                    <p class="text-truncate m-0">
                        {{ userSection.section.name }}
                    </p>
                </div>
            </mat-cell>
        </ng-container>

        <!-- Completion Column -->
        <ng-container matColumnDef="completion">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let userSection">
                <div fxLayout="row" fxLayoutAlign="space-between center">
                    <div class="completion-dropdown w-200 p-8" [ngStyle]="{ 'background-color': userSection.moduleCompletionStatus?.primaryColor }">
                        <span class="secondary-color" [ngStyle]="{ 'background-color': userSection.moduleCompletionStatus?.secondaryColor }"></span>
                        <mat-select name="status" value="{{ userSection.moduleCompletionStatus.name }}" (selectionChange)="updateStatus($event.value, userSection.section)">
                            <mat-option [value]="status.name" *ngFor="let status of moduleCompletionStatuses"> {{ status.translationLabel | translate }}</mat-option>
                        </mat-select>
                    </div>
                </div>
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let certificate; columns: displayedColumns" class="certificate" matRipple> </mat-row>
    </mat-table>
</div>
<div class="pt-24 action-buttons" fxLayout="row" fxLayoutAlign="end center">
    <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="dialogRef.close(false)"></app-white-button>

    <app-flat-button [label]="'GENERAL.BUTTON.SAVE'" (onClick)="saveChanges()"></app-flat-button>
</div>
